export default {
  title: 'Dominio de la tienda',
  description:
    'Publica las tiendas online de tus restaurantes en un dominio propio en lugar de la dirección compartida, por ejemplo pizza-mario.pedidos-tumarca.com. Añades dos registros DNS una sola vez; cada restaurante que añadas después recibe su dirección automáticamente.',
  read_only_description:
    'El dominio en el que se publican las tiendas de los restaurantes de este partner. Solo el partner puede conectarlo o cambiarlo.',
  read_only_empty: 'Este partner no ha conectado ningún dominio de tienda.',
  not_connected: {
    label: 'Dominio para las tiendas de tus restaurantes',
    hint: 'Un dominio o subdominio que te pertenezca, por ejemplo pedidos-tumarca.com. Tiene que ser un dominio distinto del que usan las apps de tu equipo, no un subdominio suyo.',
    placeholder: 'pedidos-tumarca.com',
    connect: 'Conectar',
  },
  status: {
    pending_dns: 'Esperando DNS',
    active: 'Activo',
    failed: 'Requiere acción',
    disabled: 'Desvinculado',
  },
  primary_badge: 'Principal',
  summary: {
    pending: 'Estamos esperando tus registros DNS. Suele tardar unos minutos y puede tardar unas horas.',
    failed:
      'No hemos podido confirmar todos los registros a tiempo. Corrige el registro marcado abajo y pulsa Comprobar de nuevo: a partir de ahí volvemos a comprobar.',
    failed_leave: 'Para conectar un dominio distinto, primero desvincula este.',
    live: '{{host}} está activo.',
    primary: 'Cada restaurante nuevo recibe automáticamente su dirección en este dominio.',
    standby:
      'Hazlo principal para que cada restaurante nuevo lo reciba automáticamente. Los restaurantes que ya están en otro dominio se quedan donde están.',
    regressed:
      '{{host}} está activo, pero un registro de abajo ha dejado de confirmarse. Tus tiendas siguen en línea: corrige el registro en tu proveedor de DNS.',
  },
  instructions: {
    title: 'Cómo añadir los registros',
    step_provider:
      'Inicia sesión donde se gestiona el DNS de {{root}}: normalmente la empresa donde compraste el dominio.',
    step_add: 'Añade cada registro de abajo exactamente como se muestra: su tipo, su nombre y su valor.',
    step_check: 'Guarda y haz clic en «{{button}}». Nosotros también seguimos comprobando por nuestra cuenta.',
    tip_name:
      'La mayoría de los proveedores solo quieren la parte anterior a {{root}} en el campo de nombre: _foodamigos-verify y *. El nombre completo aparece debajo, para los proveedores que lo piden.',
    tip_wildcard:
      'El registro * envía todas las direcciones bajo {{root}} a tus tiendas, así que nunca tienes que añadir un registro por restaurante.',
    tip_existing:
      'Los registros que ya existen para {{root}}, como los de tu web, tu correo o www, siguen funcionando: el registro * solo responde a los nombres que no tienen un registro propio. Si {{root}} ya tiene un registro *, sustitúyelo por el nuestro.',
    tip_cloudflare: 'En Cloudflare, pon el registro CNAME en «Solo DNS» (nube gris); si no, no podemos verlo.',
  },
  records: {
    title: 'Añade estos registros DNS para {{root}} en tu proveedor de dominio',
  },
  example: 'Después, un restaurante estará en una dirección como {{host}}.',
  example_label: 'tu-restaurante',
  buttons: {
    check_again: 'Comprobar de nuevo',
    make_primary: 'Hacer principal',
    unlink: 'Desvincular',
    retry: 'Intentar de nuevo',
  },
  primary_unavailable: 'Disponible cuando el dominio esté activo.',
  unlink_blocked_one: '{{count}} restaurante sigue en este dominio. Muévelo a otro dominio antes de desvincularlo.',
  unlink_blocked_other:
    '{{count}} restaurantes siguen en este dominio. Muévelos a otro dominio antes de desvincularlo.',
  unlink_confirm: {
    title: '¿Desvincular {{host}}?',
    description: 'Puedes volver a conectar {{host}} más adelante.',
    description_primary:
      'Los restaurantes nuevos vuelven a recibir una dirección en el dominio compartido. Puedes volver a conectar {{host}} más adelante.',
    ok: 'Desvincular',
  },
  toasts: {
    load_error: 'No se ha podido cargar tu dominio de tienda',
    load_error_read_only: 'No se ha podido cargar el dominio de tienda de este partner',
    connected: 'Dominio conectado: ahora añade los registros de abajo',
    connect_failed: 'No se ha podido conectar el dominio',
    check_started: 'Comprobando de nuevo…',
    check_failed: 'No se ha podido iniciar la comprobación. Inténtalo de nuevo en un minuto.',
    primary_set: 'Los restaurantes nuevos reciben ahora este dominio',
    primary_failed: 'No se ha podido hacer principal este dominio',
    unlinked: 'Dominio desvinculado',
    unlink_failed: 'No se ha podido desvincular el dominio',
    unlink_has_restaurants_one:
      '{{count}} restaurante sigue en {{host}}: {{names}}. Muévelo a otro dominio antes de desvincularlo.',
    unlink_has_restaurants_other:
      '{{count}} restaurantes siguen en {{host}}: {{names}}. Muévelos a otro dominio antes de desvincularlo.',
    gone: '{{host}} ya no está conectado; puede que se haya desvinculado en otra pestaña.',
  },
};
